import type { ReactNode } from 'react';
import { Typography } from '@mui/material';

export type AppNameProps = {
  children?: ReactNode;
};

/**
 * AppName component from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 * @param {AppNameProps} appNameProps - The props for the AppName component
 * @returns {ReactElement} The AppName component
 */

export const AppName = ({ children }: AppNameProps) => {
  return (
    <Typography
      variant="h5"
      component="h1"
      sx={{
        fontWeight: 500,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
      }}
    >
      {children}
    </Typography>
  );
};
